module.exports = __webpack_public_path__ + "static/media/menuHouse.2c345c9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuHouse.svg
// module id = 490
// module chunks = 0